export default "__VITE_ASSET__BXIP9mzG__"